import { COLOR_GRAY_2, COLOR_GRAY_3, COLOR_NEUTRAL_ULTRALIGHT, COLOR_WH } from '../colors.constants';

export const colorsMenu = {
  colorMenuBackground: COLOR_WH,
  colorMenuBackdrop: '#00000094',
  colorMenuItemBackground: COLOR_NEUTRAL_ULTRALIGHT,
  colorMenuItemBackgroundHover: COLOR_GRAY_2,
  colorMenuItemBorder: `1px solid ${COLOR_GRAY_3}`,
};
